/*
 * This file is part of glowingblue/orell-facade.
 *
 * Copyright (c) 2022 Glowing Blue AG.
 * Authors: Rafael Horvat.
 *
 * For the full copyright and license information, please view the LICENSE.md
 * file that was distributed with this source code.
 */

import app from 'flarum/forum/app';
import { slug } from '../../../../common';
import Component from 'flarum/common/Component';
import DateSelect from '../Inputs/DateSelect';
import ImageUpload from '../Inputs/ImageUpload';
import NumberInput from '../Inputs/NumberInput';
import Switch from '../Inputs/Switch';
import Text from '../Inputs/Text';
import Textarea from '../Inputs/Textarea';
import DeviceTabs from '../DeviceTabs';
import Select from '../Inputs/Select';
import Color from '../Inputs/Color';
import Button from 'flarum/common/components/Button';

const t = app.translator.trans.bind(app.translator);
const prfx = `${slug}.forum.banner_form.field_groups`;

const FIELD_TYPES = {
	switch: Switch,
	number: NumberInput,
	text: Text,
	textarea: Textarea,
	select: Select,
	date: DateSelect,
	image: ImageUpload,
	color: Color,
};

export default class AbstractFieldGroup extends Component {
	oninit(vnode) {
		super.oninit(vnode);
	}

	get isResponsive() {
		return false;
	}

	fields() {
		return []; // Child classes should override this method.
	}

	view() {
		const { groupKey } = this.attrs;

		const expanded = app.bannerFormState.isExpanded(groupKey);

		return (
			<div className="BannerFieldGroup">
				<div className="BannerFieldGroup__header">
					<Button
						icon={expanded ? 'fas fa-chevron-down' : 'fas fa-chevron-right'}
						className="Button Button--icon Button--flat BannerFieldGroup__header__toggle"
						onclick={() => app.bannerFormState.expand(groupKey)}
					/>
					<h3 className="BannerFieldGroup__title">{t(`${prfx}.${groupKey}`)}</h3>
				</div>
				{expanded && (
					<div className="BannerFieldGroup__body">
						{this.isResponsive ? <DeviceTabs inputs={this.renderFields.bind(this)} /> : this.renderFields()}
					</div>
				)}
			</div>
		);
	}

	renderFields(device = null) {
		const { groupKey } = this.attrs;

		return this.fields().map((field) => {
			const { name, type, options } = field;
			const Input = FIELD_TYPES[type];

			return <Input groupKey={groupKey} name={name} options={options} device={device} />;
		});
	}
}
